import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';
import { useAuth } from '../lib/auth-context.js';
import { toPersianDigits, formatJalaliGrid } from '../lib/format.js';
export function HomePage() {
    const { user } = useAuth();
    const today = new Date().toISOString().slice(0, 10);
    const { data, isLoading, error } = useQuery({
        queryKey: ['shifts', 'today', user.id],
        queryFn: () => api(`/api/shifts?from=${today}&to=${today}&userId=${user.id}`),
    });
    const todayShift = data?.shifts[0];
    return (_jsxs("div", { className: "space-y-4", children: [_jsxs("h1", { className: "text-2xl", children: ["\u0633\u0644\u0627\u0645 ", user.display_name] }), _jsxs("div", { className: "bg-white rounded p-4 shadow", children: [_jsxs("h2", { className: "font-bold mb-2", children: ["\u0634\u06CC\u0641\u062A \u0627\u0645\u0631\u0648\u0632 \u2014 ", formatJalaliGrid(today)] }), isLoading && _jsx("p", { children: "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC\u2026" }), error && _jsxs("p", { className: "text-red-600", children: ["\u062E\u0637\u0627: ", error.message] }), todayShift && (_jsx("p", { children: todayShift.isWorking
                            ? 'سر کار'
                            : todayShift.status.kind === 'leave'
                                ? `مرخصی${todayShift.status.reason ? ` (${todayShift.status.reason})` : ''}`
                                : todayShift.status.kind === 'holiday'
                                    ? `تعطیل — ${todayShift.status.name}`
                                    : 'تعریف نشده' }))] })] }));
}
